import BaseUseCase from "../../../base_use_case.js";

class ListParticipantsUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/participants`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { participants } = data; 

      participants = participants.map((participant) => {
        return {
          ...participant,
          key: participant.id,
        }
      })
      data.list = participants;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListParticipantsUseCase();
export default instance;